var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      attrs: {
        disabled: !_vm.shouldDisplayTooltip,
        content: _vm.tooltipContent,
        placement: "top"
      }
    },
    [
      _c(
        "CompassLink",
        {
          ref: "compassLink",
          staticClass: "object-link",
          attrs: {
            label: _vm.label,
            type: "secondary",
            link: _vm.link,
            target: "_blank",
            size: _vm.size,
            "data-bot": _vm.dataBot
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("template", { slot: "prefix" }, [
            _c(
              "div",
              { staticClass: "object-link-icon__wrapper" },
              [
                _c("CompassIcon", {
                  attrs: { size: _vm.sizeIcon, icon: _vm.icon }
                })
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }